<template>
    <div>
        <div class="header-tool">
            <input @input="handleSearchInput" class="form-control search-input" />
            <el-button size="mini" @click.native="download"><i class="glyphicon glyphicon-download-alt"></i></el-button>
        </div>
        <t-table
            id="mainTable"
            :data="tableData.data"
            :pageSize="queryTableParams.pageSize"
            :curPage="queryTableParams.pageNum"
            :total="tableData.total"
            @current-change="handleTableCurrentChange"
            @sort-change="handleSortable"
            @size-change="handleTablePageSize"
        >
            <t-table-column label="DAID" property="daid" width="8%" sortable/>
            <t-table-column label="Reported Trait" property="reportedTrait" width="8%" sortable/>
            <t-table-column label="Gene Symbol" property="geneSymbol" width="8%" sortable>
                <template slot-scope="{ row }">
                    <a :href="'https://www.ncbi.nlm.nih.gov/gene/?term=' + row.geneSymbol" target="_blank">{{ row.geneSymbol }}</a>
                </template>
            </t-table-column>
            <t-table-column label="Ensembl ID" property="ensg" width="10%" sortable/>
            <t-table-column label="Gene Type" property="geneBiotype" width="6%" sortable/>
            <t-table-column label="CHR" property="chr" width="5%" sortable >
                <template slot-scope="{ row }">
                    <span>chr{{ row.chr }}</span>
                </template>
            </t-table-column>
            <t-table-column label="Location" property="location" width="10%"  sortable/>
            <t-table-column label="Synonyms" property="geneSynonym" width="8%" sortable/>
            <t-table-column label="Method" property="method" width="8%" sortable/>
            <t-table-column label="P-Value" property="pvalue" width="6%" sortable/>
            <t-table-column label="Additional Info" property="addtionalInfo" width="20%" sortable>
                <template slot-scope="{ row }">
                    <p v-for="item in row.addtionalInfo.split(';')">
                        {{ item }}
                    </p>
                </template>
            </t-table-column>
        </t-table>
    </div>
</template>

<script>
import table_mix from "@/common/table_mix";
export default {
    name: "trait_gene",

    mixins: [table_mix],

    props: {
        traitId: String,
    },

    data() {
        return {};
    },

    created() {
        this.refreshTable();
    },

    computed: {
        getTableDataAjaxUrl() {
            return `trait/${this.traitId}/gene/page`;
        },
    },

    methods: {
        download() {
            window.open(`/api/trait/${this.traitId}/gene/export?keyword=${this.queryTableParams.keyword}`, '_blank')
        },
    },
};
</script>

<style scoped></style>
